// Popup.jsx
import { useEffect } from "react";
import { X } from "lucide-react";
import "./Popup.css"
/**
 * Simple mount-to-show modal.
 * Parent decides visibility by mounting / unmounting this component.
 */
export default function Popup({
  closeModal,
  title,
  children,
  small,
  width,
  headerStyle,
  shouldScroll = true,
  customHeading,
  titleStyle,
  isMyCanvasCase = false,
}) {
  // Close on Esc
  useEffect(() => {
    const handleKey = (e) => e.key === "Escape" && closeModal?.(false);
    const root = document.documentElement;
    window.addEventListener("keydown", handleKey);

    if (isMyCanvasCase) {
      const body = document.body;
      // Store original values so we can restore exact state on unmount.
      const originalRootOverflow = root.style.overflow || "";
      const originalBodyOverflow = body.style.overflow || "";
      if (shouldScroll) {
        root.style.overflow = "hidden";
        body.style.overflow = "hidden";
      }
      return () => {
        window.removeEventListener("keydown", handleKey);
        root.style.overflow = originalRootOverflow;
        body.style.overflow = originalBodyOverflow;
      };
    }

    // Store the original overflow value before changing it.
    const originalOverflow = root.style.overflow || "";
    root.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      // Restore the original overflow value to allow page scrolling.
      root.style.overflow = "scroll" || originalOverflow;
    };
  }, [closeModal, shouldScroll, isMyCanvasCase]);

  // width: string/number → { width }; plain object → spread as card styles (fixes nested { width: { width, maxWidth } } bug)
  const cardStyle =
    width == null
      ? undefined
      : typeof width === "string" || typeof width === "number"
        ? { width }
        : typeof width === "object" && !Array.isArray(width)
          ? width
          : { width };

  return (
    <div
      className="popup-overlay"
      data-canvas-chrome={isMyCanvasCase ? "true" : undefined}
      onClick={() => closeModal?.(false)}
    >
      <div className={`popup-card ${small? "mini-popup" :""}`} style={cardStyle} onClick={(e) => e.stopPropagation()}>
        <header className="popup-header" style={headerStyle}>
          {customHeading && customHeading}
          <h2 style={titleStyle}>{title}</h2>
          <button
            className="popup-close"
            aria-label="Close"
            onClick={() => closeModal?.(false)}
          >
            <X size={20} strokeWidth={2.25} />
          </button>
        </header>

        <div className="popup-body">{children}</div>
      </div>
    </div>
  );
}
